<script setup lang="ts">
import { RouterLink } from "vue-router";
import { useRoute, useRouter } from "vue-router";
import Avatar from "../components/Avatar.vue";
import Button from "../components/Button.vue";
import Icon from "../components/Icon.vue";
import { logout, openWorkspace, session } from "../composables/session";
import { profileTone } from "../composables/profileColors";
import { t } from "../i18n";
const router = useRouter();
const route = useRoute();
function pick(slug: string) {
  openWorkspace(slug);
  const next = route.query.next;
  router.push(
    typeof next === "string" && next.startsWith("/") ? next : "/inbox",
  );
}
async function leave() {
  await logout();
  router.replace("/login");
}
</script>
<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="auth-brand">
        <Icon name="chat" :size="28" /><span>{{ t("app.name") }}</span>
      </div>
      <h1>{{ t("workspaces.title") }}</h1>
      <p class="muted small">{{ t("workspaces.subtitle") }}</p>
      <div v-if="session.me?.workspaces.length" class="workspace-list">
        <button
          v-for="w in session.me.workspaces"
          :key="w.id"
          class="workspace-row"
          :disabled="!w.ready"
          @click="pick(w.slug)"
        >
          <Avatar :name="w.name" :size="36" :tone="profileTone(null, w.id)" />
          <span class="grow"
            ><strong>{{ w.name }}</strong
            ><br /><small class="muted"
              >{{
                w.support
                  ? t("platform.support.until", {
                      time: new Date(w.support.expiresAt).toLocaleTimeString(
                        [],
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        },
                      ),
                    })
                  : t(("role." + w.role) as never)
              }}<template v-if="!w.ready">
                · {{ t("workspaces.not_ready") }}</template
              ></small
            ></span
          >
          <Icon name="chevron" :size="18" class="muted" />
        </button>
      </div>
      <p v-else class="muted">{{ t("workspaces.none") }}</p>
      <RouterLink
        v-if="session.me?.platformRole"
        to="/platform"
        class="workspace-row platform-link"
      >
        <Icon name="monitor" :size="20" /><span class="grow">{{
          t("platform.open")
        }}</span
        ><Icon name="chevron" :size="18" />
      </RouterLink>
      <Button variant="ghost" @click="leave">{{ t("auth.logout") }}</Button>
    </div>
  </div>
</template>
